// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Module ID this slot belongs to (None = cross-module)
 */
export type SlotBindingModuleId = string | null;
